/**
 * Parking slot definitions
 */
export const SLOT_IDS = ['SLOT-A', 'SLOT-B'];
export const SLOTS = [
    { id: 'SLOT-A', name: 'Parkplatz A', description: 'Linker Parkplatz' },
    { id: 'SLOT-B', name: 'Parkplatz B', description: 'Rechter Parkplatz' },
];
/**
 * Business hours configuration
 */
export const BUSINESS_HOURS = {
    startHour: 6,
    endHour: 20,
};
export const DAYS_OF_WEEK = [
    { value: 1, labelKey: 'days.monday' },
    { value: 2, labelKey: 'days.tuesday' },
    { value: 3, labelKey: 'days.wednesday' },
    { value: 4, labelKey: 'days.thursday' },
    { value: 5, labelKey: 'days.friday' },
    { value: 6, labelKey: 'days.saturday' },
    { value: 0, labelKey: 'days.sunday' },
];
//# sourceMappingURL=slot.js.map